"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderDiscountAdminResponseAllOfToJSON = exports.OrderDiscountAdminResponseAllOfFromJSONTyped = exports.OrderDiscountAdminResponseAllOfFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function OrderDiscountAdminResponseAllOfFromJSON(json) {
    return OrderDiscountAdminResponseAllOfFromJSONTyped(json, false);
}
exports.OrderDiscountAdminResponseAllOfFromJSON = OrderDiscountAdminResponseAllOfFromJSON;
function OrderDiscountAdminResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'lootboxPrize': !(0, runtime_1.exists)(json, 'lootboxPrize') ? undefined : json['lootboxPrize'],
        'assignedCodes': !(0, runtime_1.exists)(json, 'assignedCodes') ? undefined : (json['assignedCodes'].map(_1.OrderDiscountUserCodeFromJSON)),
    };
}
exports.OrderDiscountAdminResponseAllOfFromJSONTyped = OrderDiscountAdminResponseAllOfFromJSONTyped;
function OrderDiscountAdminResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'lootboxPrize': value.lootboxPrize,
        'assignedCodes': value.assignedCodes === undefined ? undefined : (value.assignedCodes.map(_1.OrderDiscountUserCodeToJSON)),
    };
}
exports.OrderDiscountAdminResponseAllOfToJSON = OrderDiscountAdminResponseAllOfToJSON;
